import { useContext, useState } from "react";
import IconButton from "mobily-ui-library/lib/components/composite/iconButton/IconButton";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../../../context/GlobalContext";
import { getAccountDetails } from "../../../../api/apigeeApi";
import { Error, prefixSelector } from "../../../Util/Util";
import { RandomStringID } from "../../../Util/RandomStringID";
import { v4 as uuid } from "uuid";
import './ExistingCustomer.scss';
import InputCustom from "../../../Common/InputCustom/InputCustom";
import { Form } from "antd";
import CaptchaCustom from "../../../Common/CaptchaCustom/CaptchaCustom";

interface Props {
    rtl: boolean;
    dir?: string;
    page: string;
}

const alphaNumeric = /^[0-9]{10}$/;
const mobilePattern = /^((5)([0-9]{8})){0,9}$/;

const ExistingCustomer = ({ rtl, page }: Props) => {
    const [state, dispatch]: any = useContext(GlobalContext);
    const [count, setCount] = useState(0);
    const [captchaChecked, setCaptchaChecked] = useState(false);
    const [form] = Form.useForm();
    const { t } = useTranslation();
    const dir = rtl ? "right" : "left";

    const initialValues = {
        crNumber: state.existingCustomerData.crNumber,
        mobileNumber: state.existingCustomerData.mobileNumber,
        prefix: state.existingCustomerData.prefix || '966',
        accept: false
    }
    const time = new Date();
    const dateOnly = new Date().toISOString().split('T')[0];
    const ds = time.toISOString().replace(/[^0-9]/g, "").slice(0, 14);
    console.log(dateOnly)
    const randomID = RandomStringID(32, "aA#");


    const handleNext = (values: any) => {
        setCount(prevCount => prevCount + 1);
        if (count >= 3 && !captchaChecked) {
            Error('Captcha is Required');
            return;
        }
        const { crNumber, mobileNumber, prefix } = values;
        dispatch({ type: "LOADER", payload: { loading: true } });
        const obj = {
            crNumber,
            mobileNumber,
            prefix
        }
        getAccountDetails(crNumber).then((res: any) => {
            if (res.status === 200) {
                dispatch({ type: "LOADER", payload: { loading: false } });
                if (res.data.ListOfBusinessCustomer.length > 0) {
                    const response = res.data.ListOfBusinessCustomer[0];
                    const numToCompare = `+${prefix}${mobileNumber}`;
                    const matchNumber = response.ListOfAPs.map((item: any) => item.Mobile);

                    if (matchNumber.includes(numToCompare)) {
                        const existData = response.ListOfAPs.filter((item: any) => item.Mobile === numToCompare)[0];
                        const name = `${existData.FirstName} ${existData.LastName}`;
                        const email = existData.EmailAddress;
                        const accNum = response.AccountNumber;
                        const existingCustomerAPIRes = {
                            ID: "A306",
                            ProcessingTypeCode: "",
                            Name: `Portal_${response.CompanyName}`,
                            OriginTypeCode: "Z17",
                            Status: {
                                LifeCycleStatusCode: "",
                                UserStatusCode: "",
                            },
                            ProspectParty: {
                                ProspectPartyID: response.AccountNumber,
                                ContactParty: {
                                    PartyID: existData.RowId,
                                    RecipientPartyID: ""
                                },
                                Address: {
                                    MobileFormattedNumberDescription: mobileNumber,
                                },
                            },

                            EmployeeResponsible: {
                                RecipientPartyID: "",
                            },
                            Item: state.productInfoAPIData,
                            ZDocumentType: "Z108",
                            ZKUT_VATRegistrationNumber: '',
                            ZKUT_CompanyIdentificationNumber: "",
                            Z_Date_of_request: dateOnly,
                            Z_Description_of_Devices: "",
                            Z_DD_Comments: "",
                            ZODBNumber: "",
                            Z_ODBOperator: "",
                            ZZExisitng_Flag: "",
                            ZKUT_OTPReceivednumber: mobileNumber,
                        };
                        dispatch({
                            type: "EXISTING_CUSTOMER_DATA",
                            payload: {
                                existingCustomerAPIRes,
                                values: { ...obj, apName: name, accountNumber: accNum, email },
                                page,
                                result: response,
                                customerType: "existingcustomer",
                                createdTime: time.toISOString(),
                                uniqueId: uuid(),
                                dateString: ds,
                                randomID,
                            },
                        });
                    } else {
                        form.setFields([
                            {
                                name: 'mobileNumber',
                                value: mobileNumber,
                                errors: [t('MSDN_NotExist')],
                            },
                        ]);
                    }
                } else {
                    form.setFields([
                        {
                            name: 'crNumber',
                            value: crNumber,
                            errors: [t('Verify_entered_data')],
                        },
                    ]);
                }
            } else {
                dispatch({ type: "LOADER", payload: { loading: false } });
                Error(t("Unexpected_error"));
            }
        });
    }

    const validateMobileNumber = (_: any, value: string) => {
        if (value && !mobilePattern.test(value)) {
            return Promise.reject(t("Verify_entered_info"));
        }
        return Promise.resolve();
    }

    const validateCRNumber = (_: any, value: string) => {
        if (value && !alphaNumeric.test(value)) {
            return Promise.reject(t("Verify_entered_data"));
        }
        return Promise.resolve();
    }

    const handleCaptcha = () => {
        setCaptchaChecked(!captchaChecked)
    }
    return (
        <div className={`exisiting-customer-container container-ar-${dir}`}>
            <Form form={form} name="accordionForm" initialValues={initialValues} onFinish={handleNext}>
                <InputCustom
                    rtl={rtl}
                    maxLength={10}
                    headingleft={t("Commercial_Registration_Number_Or_Corporate_ID")}
                    name="crNumber"
                    rules={[
                        { required: true, message: `${t("Please_Enter")} ${t("CR_Number")}` },
                        { validator: validateCRNumber }
                    ]}
                />
                <InputCustom
                    rtl={rtl}
                    maxLength={9}
                    headingleft={t("Authorized_Person_Mobile_Number")}
                    prefixSelector={prefixSelector()}
                    name="mobileNumber"
                    rules={[
                        { required: true, message: `${t("Please_Enter")} ${t("Authorised_MobileNo")}` },
                        { validator: validateMobileNumber }
                    ]}
                />
                {
                    count >= 3 && <CaptchaCustom rtl={rtl} onChange={handleCaptcha} />
                }
                <IconButton width={"130px"} htmlType='submit' rtl={rtl} className="next-button">
                    {t("Next")}
                </IconButton>
            </Form>
        </div>
    );
}

export default ExistingCustomer;